import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[advancedFilterContent]',
})
export class AdvancedFilterDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
